import { AppDispatch } from '../index'
import axiosInstance from '../../config/axios'
import { serverPath } from '../../constants/api-endpoints'
import { useMessage } from '../../hooks/useMessage'
import { CabinetFullInfo, UpdateCabinetData } from '../../context/cabinet'
import { setCabinetInfo, setCabinetLoading, setCabinetUpdating } from './reduser'
import { generatePath } from 'react-router'

export const loadCabinetInfo = (cabinetUuid: string | undefined) => async (dispatch: AppDispatch) => {
  const { error } = useMessage()

  if (!cabinetUuid) {
    return;
  }

  try {
    dispatch(setCabinetLoading(true))

    const res = await axiosInstance.get<{ data: CabinetFullInfo; }>(
      serverPath.CABINET_DETAILED_INFO.replace(':id', cabinetUuid)
    )

    if (res.status === 200) {
      dispatch(setCabinetInfo(res.data.data));
    } else {
      dispatch(setCabinetInfo(null));
    }
  } catch (e: any) {
    const message = e.response?.data?.message || e.message || 'Ошибка загрузки кабинета'

    error(message)
  } finally {
    dispatch(setCabinetLoading(false))
  }
}

export const updateCabinetInfo = (cabinetUuid: string, data: UpdateCabinetData) => async (dispatch: AppDispatch) => {
  const { success, error } = useMessage()
  try {
    dispatch(setCabinetUpdating(true))

    const res = await axiosInstance.put(`${serverPath.CABINET}/${cabinetUuid}`, {
      ...data
    })

    if (res.status === 204) {
      success("Кабинет успешно обновлен!");
      return true;
    }

    return false;
  } catch (e: any) {
    const message = e.response?.data?.message || e.message || 'Не удалось обновить кабинет.'

    error(message)

    return false;
  } finally {
    dispatch(setCabinetUpdating(false))
  }
}

export const updateCabinetActive = (cabinetUuid: string, active: boolean) => async (dispatch: AppDispatch) => {
  const { success, error } = useMessage()

  try {
    dispatch(setCabinetUpdating(true))

    const res = await axiosInstance.put(
      generatePath(serverPath.ACTIVATE_CABINET, { cabinetId: cabinetUuid }),
      { active }
    )

    if (res.status === 204) {
      success(`Доступ кабинета изменен`)
      return true;
    }

    return false;
  } catch (e: any) {
    const message = e.response?.data?.message || e.message || 'Ошибка изменения доступа'

    error(message)

    return false;
  } finally {
    dispatch(setCabinetUpdating(false))
  }
}
